import * as React from 'react';

function SvgWarningCircle(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.667v4.666c0 .368-.448.667-1 .667s-1-.299-1-.667V9.667C9 9.299 9.448 9 10 9s1 .299 1 .667zM11 6.007a1 1 0 11-2 0 1 1 0 012 0z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgWarningCircle;
